var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-cascader',{ref:"bumenref",staticStyle:{"width":"100%"},attrs:{"size":_vm.size,"value":_vm.value1,"options":_vm.bumendata,"props":_vm.props,"placeholder":"请选择部门","clearable":""},on:{"change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }